import { render } from "./AsideCustomerDashboard.vue?vue&type=template&id=9162f9b8"
import script from "./AsideCustomerDashboard.vue?vue&type=script&lang=js"
export * from "./AsideCustomerDashboard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__